// extracted by mini-css-extract-plugin
module.exports = {"container":"Signature_container__2-Svx","plusContainer":"Signature_plusContainer__9ARbF","signature":"Signature_signature__13809"};